module.exports = __webpack_public_path__ + "static/media/cognito_dashboard_active.309b3f99.svg";